<template>
  <UiModal :title="title" type="huge" @close="$emit('close')">
    <iframe
      :src="`https://www.youtube.com/embed/${videoId}`"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </UiModal>
</template>

<script lang="ts" setup>
defineProps({
  title: String,
  videoId: String,
});
</script>
<style lang="scss" scoped>
iframe {
  padding: 0;
  margin: 10vw;
  width: calc(100vw - 20vw);
  height: calc((100vw - 20vw) * 0.56);
}

@include lg-block {
  iframe {
    padding: 80px 10px 40px;
    width: 854px;
    height: 600px;
    margin: 0;
  }
}
</style>
